import InscriptionsEnAttente from "@/pages/super-admin/components/InscriptionsEnAttente";

export default function SuperAdminInscriptionsPage() {
  return <InscriptionsEnAttente />;
}